import React, { Fragment, useState, useEffect } from "react";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TablePagination,
} from "@material-ui/core";

//react-router-dom
import { Link, useHistory } from "react-router-dom";

//rect-redux
import { connect, useSelector } from "react-redux";

//image
import Male from "../../assets/images/male.png";

//action
import {
  getReportedUser,
  dismissUserReport,
} from "../../store/reportedUser/action";

import { warningv2, alert, permissionError } from "../../util/Alert";

//dayjs
import dayjs from "dayjs";
import $ from "jquery";
import { baseURL } from "../../util/Config";

//pagination
const TablePaginationActions = React.lazy(() => import("./TablePagination"));

const ReportedUser = (props) => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedAttachment, setSelectedAttachment] = useState(null);

  const report = useSelector((state) => state.report.reportedUser);
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  useEffect(() => {
    props.getReportedUser(); //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData(report);
  }, [report]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewUser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.removeItem("userFollow");
    history.push("/admin/user/detail");
  };

  const handleOpenAttachment = (attachment) => {
    setSelectedAttachment(attachment || { type: null, url: null });
  };

  const handleCloseAttachment = () => {
    setSelectedAttachment(null);
  };

  const isVideoAttachment = (attachment) => {
    const type = attachment?.type?.toLowerCase();
    const url = attachment?.url?.toLowerCase() || "";

    return (
      type === "video" ||
      [".mp4", ".mov", ".webm", ".m4v", ".avi", ".mkv"].some((extension) =>
        url.includes(extension),
      )
    );
  };

  const handleDismissReport = (userId) => {
    warningv2(
      "DISMISS REPORT",
      "Are you sure you want to dismiss all pending reports for this user?",
    )
      .then(async (confirmed) => {
        if (!confirmed) return;
        if (!hasPermission) return permissionError();

        const succeeded = await props.dismissUserReport(userId);
        if (succeeded)
          alert("Dismissed!", "Reports have been dismissed!", "success");
      })
      .catch((error) => console.log(error));
  };

  // set default image

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", `${baseURL}storage/male.png`);
    });
  });

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Reported User</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Reported User
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-body card-overflow">
              <table className="table" style={{ borderCollapse: "collapse" }}>
                <thead className="text-center">
                  <tr>
                    <th>No</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Unique Id</th>
                    <th>Country</th>
                    <th>Count</th>
                    <th>Info</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data.length > 0 ? (
                    (rowsPerPage > 0
                      ? data.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : data
                    ).map((data, index) => {
                      return (
                        <Fragment key={data?._id?._id || index}>
                          <tr
                            data-toggle="collapse"
                            data-target={`#demo${index}`}
                            className="accordion-toggle pointer-cursor"
                          >
                            <td>{index + 1}</td>
                            <td>
                              <img
                                height="50px"
                                width="50px"
                                alt="app"
                                className="mx-auto"
                                src={data._id?.image ? data._id.image : Male}
                                style={{
                                  boxShadow:
                                    "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                  border: "2px solid #fff",
                                  borderRadius: 10,
                                  objectFit: "cover",
                                  display: "block",
                                }}
                                onerror='this.src=,`${baseURL}storage/male.png`"'
                              />
                            </td>
                            <td>{data._id?.name}</td>
                            <td>{data._id?.uniqueId}</td>
                            <td className="text-info">
                              {data?._id?.country ? data?._id?.country : "-"}
                            </td>
                            <td className="text-danger">{data?.count}</td>
                            <td className="pointer-cursor">
                              <i className="fas fa-info-circle fa-lg"></i>
                            </td>
                            <td onClick={(event) => event.stopPropagation()}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span
                                  className="text-danger-2 pointer-cursor"
                                  onClick={() => handleViewUser(data._id)}
                                >
                                  View User
                                </span>
                                <span
                                  className="text-danger mt-2 pointer-cursor"
                                  onClick={() =>
                                    handleDismissReport(data._id?._id)
                                  }
                                >
                                  Dismiss Report
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="8" className="hiddenRow">
                              <div
                                id={`demo${index}`}
                                className="accordian-body collapse"
                              >
                                <h6 className="text-danger">
                                  Report User Detail
                                </h6>
                                <table className="w-100">
                                  <thead>
                                    <tr>
                                      <th>No</th>
                                      <th>Image</th>
                                      <th>Name</th>
                                      <th>Unique Id</th>
                                      <th>Country</th>
                                      <th>Description</th>
                                      <th>Attachment</th>
                                      <th>Arrived on</th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    style={{
                                      maxHeight: 100,
                                      overflowY: "auto",
                                    }}
                                  >
                                    {data.report.length > 0 ? (
                                      data.report.map((report, no) => {
                                        const attachment = report?.attachment;
                                        const hasAttachment = !!attachment?.url;

                                        return (
                                          <tr key={report?._id || no}>
                                            <td>{no + 1}</td>
                                            <td>
                                              <img
                                                height="35px"
                                                width="35px"
                                                alt="app"
                                                src={
                                                  report?.fromUserId?.image
                                                    ? report?.fromUserId.image
                                                    : Male
                                                }
                                                style={{
                                                  boxShadow:
                                                    "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                                  border: "2px solid #fff",
                                                  borderRadius: 10,

                                                  objectFit: "cover",
                                                }}
                                              />
                                            </td>
                                            <td>{report?.fromUserId?.name}</td>
                                            <td>
                                              {report?.fromUserId?.uniqueId}
                                            </td>
                                            <td className="text-info">
                                              {report?.fromUserId?.country
                                                ? report.fromUserId?.country
                                                : "-"}
                                            </td>
                                            <td>{report?.description}</td>
                                            <td>
                                              <span
                                                className="pointer-cursor"
                                                style={{
                                                  color: hasAttachment
                                                    ? "#1976d2"
                                                    : "#6c757d",
                                                  textDecoration: "underline",
                                                }}
                                                onClick={() =>
                                                  handleOpenAttachment(
                                                    attachment,
                                                  )
                                                }
                                              >
                                                {hasAttachment
                                                  ? `View ${
                                                      isVideoAttachment(
                                                        attachment,
                                                      )
                                                        ? "Video"
                                                        : "Photo"
                                                    }`
                                                  : "No Attachment"}
                                              </span>
                                            </td>

                                            <td>
                                              {dayjs(report?.date).format(
                                                "DD MMM, YYYY",
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan="8" align="center">
                                          Nothing to show!!
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <TablePagination
        id="pagination"
        component="div"
        rowsPerPageOptions={[5, 10, 25, 100, { label: "All", value: -1 }]}
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
      <Dialog
        open={!!selectedAttachment}
        onClose={handleCloseAttachment}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <span
            className="text-danger pointer-cursor float-end"
            onClick={handleCloseAttachment}
          >
            Close
          </span>
        </DialogTitle>
        <DialogContent>
          {selectedAttachment?.url ? (
            isVideoAttachment(selectedAttachment) ? (
              <video
                src={selectedAttachment.url}
                controls
                style={{
                  width: "100%",
                  maxHeight: 500,
                  borderRadius: 12,
                  backgroundColor: "#000",
                }}
              />
            ) : (
              <img
                src={selectedAttachment.url}
                alt="Report attachment"
                style={{
                  width: "100%",
                  maxHeight: 500,
                  objectFit: "contain",
                  borderRadius: 12,
                }}
              />
            )
          ) : (
            <div
              style={{
                minHeight: 220,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#6c757d",
                fontWeight: 500,
              }}
            >
              No attachment available for this report.
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { getReportedUser, dismissUserReport })(
  ReportedUser,
);
